module.exports = __webpack_public_path__ + "static/media/PetIcon-green.4a4edcb2.svg";